module.exports = __webpack_public_path__ + "img/amy.41c5758c.jpg";